import Button from "../../fragments/Button";
import KofiIcon from "./kofi-icon.png";
import PlayerList from "./PlayerList";
import ShareButton from "./ShareButton";

const Sidebar = ({ room, user, children }) => {
  return (
    <>
      {user.isGuest ? (
        <div className="grow-0 p-4 sm:px-6">
          <h2 className="my-2 text-lg tracking-tight">
            {gettext("Welcome to TriviaRoyale!")}
          </h2>
          <p className="text-gray-700">
            {gettext(
              "You can play the game as long as you like but your player is temporary. To compete on the leaderboards and save your score, register your account!"
            )}
          </p>
          <Button href={user.convertUrl} primary className="mt-2">
            {gettext("Register now!")}
          </Button>
        </div>
      ) : null}
      <div className="flex-1 p-4 sm:px-6">
        <h2 className="my-2 text-lg tracking-tight">{gettext("Your Game")}</h2>
        <div>
          <ShareButton />
        </div>
        <div>
          <Button href={room.reporturl} small className="my-2 w-full">
            {gettext("Report Question")}
          </Button>
        </div>
        <div>
          <Button
            href="https://ko-fi.com/Y8Y7A9CPA"
            small
            className="my-2 w-full"
          >
            <img src={KofiIcon} className="w-5 h-auto mr-2" alt="KoFi" />
            {gettext("Support me on Ko-fi")}
          </Button>
        </div>
      </div>
      <div className="flex-1">
        <PlayerList />
      </div>
      {children}
    </>
  );
};
export default Sidebar;
